import {ProductColor} from '../models/dto/common/productColor'

export const pickerColors: ProductColor[] = [
  {
    color: '#ffffff',
    colorSecondary: '#ffffff',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Fehér',
  },
  {
    color: '#efe1be',
    colorSecondary: '#efe1be',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Bézs',
  },
  {
    color: '#fad017',
    colorSecondary: '#fad017',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Citrom',
  },
  {
    color: '#f8ab1a',
    colorSecondary: '#f8ab1a',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Napsárga',
  },
  {
    color: '#cae210',
    colorSecondary: '#cae210',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Lime',
  },
  {
    color: '#f36b20',
    colorSecondary: '#f36b20',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Narancs',
  },
  {
    color: '#c91e25',
    colorSecondary: '#c91e25',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Piros',
  },
  {
    color: '#6d1229',
    colorSecondary: '#6d1229',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Bordó',
  },
  {
    color: '#f68cc4',
    colorSecondary: '#f68cc4',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Rózsaszín',
  },
  {
    color: '#ab1c6d',
    colorSecondary: '#ab1c6d',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Bíbor',
  },
  {
    color: '#7a104e',
    colorSecondary: '#7a104e',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Mályva',
  },
  {
    color: '#a88ccc',
    colorSecondary: '#a88ccc',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Világoslila',
  },
  {
    color: '#412f82',
    colorSecondary: '#412f82',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Sötétlila',
  },
  {
    color: '#76abdc',
    colorSecondary: '#76abdc',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Babakék',
  },
  {
    color: '#3c6bbc',
    colorSecondary: '#3c6bbc',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Világoskék',
  },
  {
    color: '#2645a1',
    colorSecondary: '#2645a1',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Királykék',
  },
  {
    color: '#1e284e',
    colorSecondary: '#1e284e',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Sötétkék',
  },
  {
    color: '#53be36',
    colorSecondary: '#53be36',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Almazöld',
  },
  {
    color: '#1d522a',
    colorSecondary: '#1d522a',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Sötétzöld',
  },
  {
    color: '#18261b',
    colorSecondary: '#18261b',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Katonazöld',
  },
  {
    color: '#297075',
    colorSecondary: '#297075',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Aqua',
  },
  {
    color: '#1a3a5b',
    colorSecondary: '#1a3a5b',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Türkiz',
  },
  {
    color: '#805640',
    colorSecondary: '#805640',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Capuccino',
  },
  {
    color: '#3a2317',
    colorSecondary: '#3a2317',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Barna',
  },
  {
    color: '#575c5e',
    colorSecondary: '#575c5e',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Szürke',
  },
  {
    color: '#010203',
    colorSecondary: '#010203',
    lineColor: '',
    colorGraphicsBackground: '',
    pages: [],
    title: 'Fekete',
  },
]
